import { Button, Label, Spinner, TextInput } from 'flowbite-react';
import React from 'react';
import { FaLinkedinIn } from 'react-icons/fa6';
import { RxCross2 } from 'react-icons/rx';
import { useMutation, useQueryClient } from 'react-query';
import { useNavigate } from 'react-router-dom';
import { validateLinkedInProfileUrl } from 'shared-utils';
import { connectWithLinkedIn } from 'src/apis/user';
import { useToast } from 'src/context/ToastProvider';
import { useUserContext } from 'src/context/UserProvider';
import EditProfileFromLinkedIn from 'src/pages/profile/EditProfileFromLinkedin';
import { Drawer } from '../shared/Drawer';
import { useMediaQuery } from '@mui/material';
import { useThemeContext } from 'src/context/ThemeProvider';

type LinkedInProfilProps = {
	toggleDrawer: (newOpen: boolean) => () => void;
	onSuccess?: (data: string) => void;
	heading?: string;
	description?: string;
};

const LinkedInImportForm = ({ toggleDrawer, onSuccess, heading, description }: LinkedInProfilProps) => {
	const toast = useToast();
	const navigate = useNavigate();
	const { user } = useUserContext();
	const queryClient = useQueryClient();
	const [linkedInUrl, setLinkedInUrl] = React.useState('');
	const [openLinkedEditProfile, setOpenLinkedEditProfile] = React.useState(false);
	const isMobile = useMediaQuery('(max-width:960px)');

	const connectWithLinkedInFn = useMutation({
		mutationKey: 'connectWithLinkedIn',
		mutationFn: connectWithLinkedIn,
		onSuccess() {
			queryClient.refetchQueries(['getUserProfile']);
			queryClient.refetchQueries(['getAllApplications']);
			toast({
				title: 'Profile Updated successfully',
				type: 'success',
			});
			toggleDrawer(false);
			console.log('linkedInUrl:', linkedInUrl);
			console.log('onSuccess:', onSuccess);
			if (onSuccess) onSuccess(linkedInUrl);
			// else setOpenLinkedEditProfile(true);
			else navigate(`/profile/linkedin-edit`);
			// else navigate(`/profile/${user?.handler}?selected=Profile`);
		},
		onError(err) {
			queryClient.refetchQueries(['getUserProfile']);
			queryClient.refetchQueries(['getAllApplications']);
			console.log('err:', err);
			toast({
				title: 'Profile Updated successfully',
				type: 'success',
			});
			toggleDrawer(false);
			console.log('linkedInUrl:', linkedInUrl);
			console.log('onSuccess:', onSuccess);
			if (onSuccess) onSuccess(linkedInUrl);
			// else setOpenLinkedEditProfile(true);
			else navigate(`/profile/linkedin-edit`);
			// toast({
			// 	title: 'Something went wrong!',
			// 	type: 'error',
			// });
		},
	});

	const { themeMode } = useThemeContext();
	return (
		<>
			{/* <button
				onClick={toggleDrawer(false)}
				className="absolute z-[1] top-[10px] !p-[2px] rounded-[8px] text-[#9CA3AF] right-[10px]"
			>
				<RxCross2 className="w-[20px] h-[20px]" />
			</button> */}
			<div className="relative dark:bg-[#1F2A37] bg-inherit px-[16px] py-[24px] rounded-t-[16px]">
				<h6 className="items-center dark:text-[#FAFAFC] text-[#555770] font-inter text-[20px] font-[700] leading-[24px]">
					{heading ? (
						heading
					) : (
						<>
							Import from{' '}
							<span className="bg-[#0a66c2] relative top-[2px] max-w-max rounded-[1.5px] inline-flex items-center justify-center text-center">
								<FaLinkedinIn className="w-[70%] m-auto text-white" />
							</span>{' '}
							LinkedIn
						</>
					)}
				</h6>
				{description && (
					<p className="mt-[16px] dark:text-[#E4E4EB] font-inter text-[14px] font-[500] leading-[20px]">
						If you wish to interview for this job, please update your profile details.
					</p>
				)}

				<form
					onSubmit={e => {
						e.preventDefault();
						try {
							const urlObject = new URL(linkedInUrl || '');

							// Remove all query parameters
							urlObject.search = '';

							// Get the cleaned URL
							const cleanedUrl = urlObject.toString();

							if (validateLinkedInProfileUrl(cleanedUrl)) {
								connectWithLinkedInFn.mutate({ linkedInProfileLink: cleanedUrl });
							} else {
								toast({
									title: 'Invalid LinkedIn url',
									type: 'error',
								});
							}
						} catch (err) {
							toast({
								title: 'Invalid LinkedIn url',
								type: 'error',
							});
						}
					}}
					className="mt-[25px]"
				>
					<div className="mb-[5px]">
						<Label
							className="font-inter text-sm font-medium dark:text-white"
							htmlFor="linkedInUrl"
							value="LinkedIn Profile URL"
						/>
					</div>
					<TextInput
						style={
							themeMode === 'dark'
								? {
										color: 'white',
										backgroundColor: '#374151',
										border: '1px solid #4B5563',
										fontFamily: "'Inter', sans-serif",
										fontSize: '14px',
								  }
								: {}
						}
						id="linkedInUrl"
						name="linkedInUrl"
						onChange={e => {
							setLinkedInUrl(e.target.value);
						}}
						placeholder="https://www.linkedin.com/in/user-name/"
					/>

					<div className="text-center mt-[12px]">
						<a
							href="https://www.linkedin.com/in/"
							target="_blank"
							className="text-center font-inter text-sm font-medium underline  text-[#6698FA]"
						>
							Know your profile URL?
						</a>
					</div>

					<div className="mt-[24px] flex items-center gap-[16px]">
						<Button
							disabled={connectWithLinkedInFn?.isLoading || !linkedInUrl}
							type="submit"
							color="purplePlaced"
							className="flex-1"
						>
							{connectWithLinkedInFn?.isLoading ? <Spinner /> : 'Import & Update'}
						</Button>
						<Button type="button" color="dark" className="bg-[#555770]" onClick={toggleDrawer(false)}>
							Cancel
						</Button>
					</div>
				</form>
			</div>

			<Drawer
				maxHeight="500px"
				maxWidth="800px"
				modalMaxWidth="900px"
				isModal={!isMobile}
				isOpen={openLinkedEditProfile}
				header={<div className="p-4 text-base font-inter font-[700] ">Confirm Changes</div>}
				body={
					<div className="pb-[100px] md:mt-[-30px]">
						<EditProfileFromLinkedIn />
					</div>
				}
				onClose={() => {
					setOpenLinkedEditProfile(false);
				}}
			/>
		</>
	);
};

export default LinkedInImportForm;
